import { type IContentItem, type Elements } from '@kontent-ai/delivery-sdk';
import { getSingleChoiceValue } from '@r-and-a-shared-ui/common-kontent-client/utils';

type RichTextEntry = IContentItem<{
  content: Elements.RichTextElement;
  membership_type?: Elements.MultipleChoiceElement;
  text_size?: Elements.MultipleChoiceElement;
}>;

export const rich_text = (entry: RichTextEntry) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements } = entry || {};

  return {
    content: elements?.content,
    membershipType: elements?.membership_type
      ? getSingleChoiceValue(elements.membership_type)
      : undefined,
    textSize: elements?.text_size
      ? getSingleChoiceValue(elements.text_size)
      : undefined,
  };
};

export default rich_text;
